import { Box, Typography, styled } from "@mui/material";
import { colors } from "../../../../theme/colors";

export const ChipsContainer = styled(Box)(({ theme }) => ({
  fontFamily: "Nunito",
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
  fontSize: "14px",
  [theme.breakpoints.down("sm")]: {
    justifyContent: "flex-end",
    flex: 1,
    minWidth: 0,
  },
}));

export const ViewChip = styled(Box)(({ theme }) => ({
  fontWeight: 600,
  color: colors.text.action,
  fontFamily: "Nunito",
  fontSize: "14px",
  whiteSpace: "nowrap",
  padding: "0 8px",
  height: "24px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: colors.background.lightBlue,
  borderRadius: "16px",
  border: `1px solid ${colors.text.action}`,
  [theme.breakpoints.down("sm")]: {
    fontSize: "13px",
    height: "22px",
  },
}));

export const TreatmentStepEmptyValue = styled(Typography)(({ theme }) => ({
  fontSize: "12px",
  fontWeight: 400,
  color: colors.border.medium,
  fontFamily: "Nunito",
  textTransform: "uppercase",
  [theme.breakpoints.down("sm")]: {
    textAlign: "right",
    flex: 1,
  },
}));

/** @deprecated Use TreatmentStepEmptyValue */
export const EmptyValue = TreatmentStepEmptyValue;

export const EditChipsContainer = styled(Box)({
  fontFamily: "Nunito",
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
  alignItems: "center",
  fontSize: "14px",
  minHeight: "24px",
});

export const EditChip = styled(Box)({
  fontWeight: 600,
  color: colors.text.action,
  fontFamily: "Nunito",
  fontSize: "14px",
  whiteSpace: "nowrap",
  padding: "0 4px 0 8px",
  height: "24px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "4px",
  backgroundColor: colors.background.lightBlue,
  borderRadius: "16px",
  border: `1px solid ${colors.text.action}`,
});

export const EditChipRemove = styled("button")({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  margin: 0,
  border: "none",
  background: "transparent",
  cursor: "pointer",
  color: colors.text.action,
  lineHeight: 0,
});

export const EditAddButton = styled("button", {
  shouldForwardProp: (prop) => prop !== "variant",
})<{ variant?: "code" | "icon" }>(({ variant = "code", disabled }) => ({
  fontWeight: 600,
  color: disabled ? colors.text.secondary : colors.border.medium,
  fontFamily: "Nunito",
  fontSize: "14px",
  whiteSpace: "nowrap",
  padding: variant === "icon" ? 0 : "0 8px",
  width: variant === "icon" ? "24px" : "auto",
  height: "24px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "transparent",
  borderRadius: variant === "icon" ? "50%" : "16px",
  border: `1px dashed ${disabled ? colors.border.light : colors.border.medium}`,
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: disabled ? 0.6 : 1,
  flexShrink: 0,
}));

export const EditValuesCell = styled(Box)({
  minWidth: 0,
  cursor: "pointer",
});
